import { Card, CardHeader, Stack } from '@mui/material';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import CompanyPlatformInfo from './CompanyPlatformInfo';
import CompanySubscriptions from './CompanySubscriptions';

function CompanyPlatformSubscription() {
  return (
    <>
      <Helmet>
        <title>BVT Agent - Platform Subscription</title>
      </Helmet>
      <Stack spacing={3}>
        <CompanyPlatformInfo/>
        <CompanySubscriptions/>
      </Stack>
    </>
  );
}

export default CompanyPlatformSubscription; 